<template lang='pug'>
.agreement

	h1.title
		span(v-if='agreement.facilities.length > 1')
			span.agreement-facility(v-for='( facility, i ) in agreement.facilities') {{ i + 1 }}. {{ facility.name }} No. {{ facility.number }}
		span(v-else-if='agreement.facilities.length === 1') {{ agreement.facilities[0].name }} No.{{ agreement.facilities[0].number }}
		span(v-else) No Facility

	.agreement-info

		p.type {{ agreement.agreementCategory.description }}

		.box

		p.record-owner {{ agreement.recordOwner }}

	p.date {{ formatDate( agreement.dateRecorded, 'MMMM DD, YYYY' ) }}

	.button-container
		.expand-info(
			:class='{ "active-link" : ( activeComp === "expandInfo" ) }'
			@click='setActiveComp( "expandInfo" )'
		)
			p Expand all Info
			.clickable-arrow(:class='expandState')


	.info(
		v-show='activeComp === "expandInfo"'
	)

		list-layout(
			:layout='listItems'
			:parentObj='formattedAgreement'
			:class='{ "slide-in" : activeComp === "expandInfo" }'
		)

</template>

<script>
import ListLayout from '@/components/ListLayout';
import DocumentList from '@/components/DocumentList';

// eslint-disable-next-line no-unused-vars
import Submit from '@/lib/Submit';
import { GetAgreement } from '@/lib/API';
import { objectOrNull } from '@/lib/vue-validators';
import { clone, FormatDate } from '@/lib/utils';

export default {
	name : 'agreement',

	props : {
		agreement : {
			required  : true,
			validator : objectOrNull,
		}
	},

	data : () => ( {

		expandState : 'close',

		fullAgreement : null,

		copyMessageState : 'hidden',
		copyMessage      : null,

		activeComp : null,

		url : null,

	} ),

	computed : {

		formattedAgreement() {
			const { agreement } = this;
			const {
				dateRecorded,
				agreementCategory,
				...otherProps
			} = agreement;

			const dates = {
				dateRecorded,
			};

			const formattedDates = Object.keys( dates ).reduce( ( obj, key ) => {
				const date = dates[key];
				const added = {};

				added[key] = this.formatDate( new Date( date ), 'MMMM D, YYYY', 'GMT' );

				return {
					...obj,
					...added,
				};
			}, {} );

			return {
				...formattedDates,
				...otherProps,
				agreementCategory,
			};
		},

		listItems() {
			return {
				title : 'Agreement',
				items : {
					facilities : {
						items : {
							name : 'Facilities',
						}
					},
					dateRecorded : 'Recorded Date',
					recordNumber : 'Record #',
					recordOwner  : 'Record Owner',
					job          : {
						parent : this.formattedAgreement,
						items  : {
							number : 'Job/Misc. Job #',
						},
					},
					wasteWater        : 'Waste Water',
					agreementCategory : {
						items : {
							description : 'Category',
						},
					},
					type           : 'Type',
					comments       : 'Comments',
					gisReference   : 'GIS Reference',
					vaultReference : 'Vault Reference',
					location       : {
						title  : 'Location Information',
						parent : this.agreement,
						items  : {
							mappedInGis : 'Mapped In GIS',
							t           : 'T',
							s           : 'S',
							r           : 'R',
							q           : 'Q',
							location    : {
								parent : this.agreement.location,
								items  : {
									description : 'Cross Streets',
								}
							}
						},
					},
					driveLink : 'Drive Link',
				}
			};
		},

	},

	watch : {

		expandState( val ) {

			if ( val === 'open' && this.fullAgreement === null ) {
				GetAgreement( this.agreement.agreementsKey )
					.then( ( agreementInfo ) => {

						this.fullAgreement = clone( agreementInfo );

					} );
			}

		},

	},

	methods : {

		setActiveComp( comp ) {

			if ( comp === this.activeComp ) {
				this.activeComp = null;
				return;
			}

			this.activeComp = comp;
		},

		formatDate( date, format ) {
			return FormatDate( date, format, 'GMT' );
		}

	},

	components : {
		ListLayout,
		DocumentList,
	}
};
</script>

<style lang='scss'>

.agreement {
	display: flex;
	flex-flow: column;
	width: 100%;
	align-items: center;
	padding: 0 25px;

	>.title {
		color: $input-color;
		font-size: 36px;
		font-weight: 500;
		text-align: center;

		.agreement-facility {

			&:not(:first-of-type) {
				margin-left: 25px;
			}
		}
	}

	.agreement-info {
		display: flex;
		flex-flow: row;
		justify-content: space-around;
		align-items: center;
		font-size: 18px;

		.type {
			font-weight: 300;
		}

		.box {
			margin: 0 15px;
			height: 6px;
			width: 6px;
			background: $input-color;
			border-radius: 2px;
		}

		.record-owner {
			color: $color-primary;
			font-weight: 300;
		}
	}

	.date {
		font-size: 18px;
		margin-top: 5px;
		font-weight: 300;
	}

	.button-container {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		margin: 50px 0;
		position: relative;

		> * {
			align-self: stretch;
			display: flex;
			align-items: center;
			padding-bottom: 15px;
			margin: 0 15px;

			&.active-link {
				position: relative;

				&::after {
					content: '';
					position: absolute;
					background: $color-primary;
					height: 2px;
					width: 100%;
					bottom: 0;
					border-radius: 3px;
				}
			}
		}

		.copy-url {

			p {
				color: $alternateGrey;
				font-weight: 300;
				cursor: pointer;
				transition: color .2s ease-in;
			}

			.copied-text {
				left: 50%;
				transform: translateX(-50%);
				width: fit-content;
			}
		}

		.view-document-container {

			.view-document {
				margin: 0;
				background: white;
				color: $color-primary;
				box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.15), 0px 0px 6px rgba(0, 0, 0, 0.1);
			}
		}
	}

	.document-list {
		position: relative;
		padding: 0 30px 30px 30px;
		width: 100%;
		left: 0;
		opacity: 1;
		transform: translateY(0);
		pointer-events: all;
		z-index: 1;
		max-height: 1000px;
		transition: max-height .2s ease-in, transform .2s ease-in, opacity .2s ease-in;

		&.closed {
			opacity: 0;
			transform: translateY(-100%);
			padding: 0 30px;
			z-index: -1;
			max-height: 0;
			pointer-events: none;
		}
	}

	.info {

		.list-layout {
			padding: 0 30px;

			.list-layout {
				padding: 0;
			}

			&.slide-in {
				padding: 0 30px 30px 30px;
			}

			.list-layout-facility, .list-layout-agreementCategory {
				width: auto;
			}

			.list-item.item-facility,
			.list-item.item-agreementCategory {
				flex: 2 2 48%;
			}
		}

		.list-item.item-title {
			flex: 1 1 48%;
		}
	}
}

@media only screen and ( max-width: 640px ) {

	.agreement {
		align-items: flex-start;

		h1.title {
			text-align: left;
		}

		.agreement-info,
		p.date {
			display: none;
		}

		.button-container {
			margin: 0;

			.view-document-container {
				display: none;
			}

			.expand-info {
				margin: 0;

				&::after {
					display: none;
				}
			}
		}

		.info {

			.list-layout.slide-in {
				padding: 0 0 30px 0;

				.title {
					display: none;
				}

				.list-item {
					flex: 0 0 100%;
				}
			}
		}
	}
}
</style>
